import ImageWithText2, { ImageWithText2Props } from './ImageWithText2'

export default ImageWithText2

export { ImageWithText2 }
export type { ImageWithText2Props }
